import PaytoIcon from 'assets/icons/payments/payto-icon-2.svg';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { format } from 'helpers';
import useAddTransaction from 'hooks/form-add-transaction/useAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';
import { functionUtils } from 'utils';
import Popup from './popup';

const UpdatePaytoAccountSuccessModal = ({ isShow, action }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const { paytoAccountAuthorising } = usePaytoStore();
  const { getTotalToPay } = useAddTransaction();
  const { isAddTransactionPage } = usePage();
  const { getTotalPayAmount } = useFxFormAddTransactionStore();

  const isAgreementByBsb = !paytoAccountAuthorising?.payId;

  const totalToPay = isAddTransactionPage
    ? getTotalToPay()
    : getTotalPayAmount();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const getPayToAccountString = () => {
    if (isAgreementByBsb)
      return `
    ${paytoAccountAuthorising?.bankName} ${paytoAccountAuthorising?.accountNumber}
    `;
    return `PayID (${paytoAccountAuthorising?.payId})`;
  };

  return (
    <Popup
      isOpen={isShow}
      imageSrc={PaytoIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
        objectFit: 'contain',
      }}
      alignContent="left"
      text={t('form_update_payto_account_success_title')}
      content={t('form_update_payto_account_success_desc', {
        account: getPayToAccountString(),
        maxAmount: format.toAmountFloatStr(paytoAccountAuthorising?.maxAmount),
        totalToPay: format.toAmountFloatStr(totalToPay),
      })}
      buttonLabel2={t('button_continue')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default UpdatePaytoAccountSuccessModal;
